import EmojiInserterComponent from '@intercom/embercom-composer/components/emoji-inserter';
export default EmojiInserterComponent;
